import { Backdrop } from './lib/backdrop.js';
customElements.define('cipublic-backdrop', Backdrop);
//# sourceMappingURL=cipublic-backdrop.js.map